import Head from "next/head";
import React from "react";

const MetaHead = ({ metadataTags }: any) => (
    <Head>
        <link
            href="https://cdn.jsdelivr.net/npm/katex@0.15.3/dist/katex.min.css"
            rel="stylesheet"
        />

        <title>
            {metadataTags?.title || "MathAI - India's 1st AI math coach"}
        </title>

        <meta
            property="og:site_name"
            content="MathAI - India's 1st AI math coach"
        />
        <meta
            property="og:title"
            content={
                metadataTags?.title || "MathAI - India's 1st AI math coach"
            }
        />
        <meta
            property="og:description"
            content={
                metadataTags?.description ||
                "MathAI - India's 1st AI math coach"
            }
        />
        <meta property="og:image" content={metadataTags?.image || ""} />
    </Head>
);

export default MetaHead;
